const donationDefaultState = {
  donationPeriod: '單次捐款', // 單次捐款 或是 定期定額 （前端自定義欄位）
  donationOwner: '', // 捐款名義 (個人名義/團體名義/匿名)
  donationWay: '', // 捐款方式 (ATM/LINE)

  amount: '', // 捐款金額
  isAnonymous: '', // 是否為匿名 True/False
  showOnDonationList: false, // 是否要在捐贈名冊上顯示名稱
  preferredNotification: true, // 是否要收到文宣
  campaignId: '', // 如果有行銷活動，網址會帶上活動ID

  contact: {
    lastName: '', // 聯絡人姓氏,
    firstName: '', // 聯絡人名字
    birthDate: '', // 出生年月日（個人名義）
    email: '', // Email
    phone: '', // 手機號碼

    groupName: '', // 組織名稱
  },

  receipt: {
    type: '', // 收據: "寄送單筆電子收據", "不需要收據", or "寄送年度紙本收據"
    title: '', // 收據抬頭 (定期定額)
    idNo: '', // 收據: 收據身分證字號
    etaxCheck: false, // 自動上傳國稅局抵減所得稅額 True/False (只有個人有)
    mailingCity: '', // 縣市  台北市
    mailingDistrict: '', // 鄉鎮市區 信義區
    mailingZipCode: '', //  100
    mailingAddress: '', // 地址 松仁路7號
  },

  creditCard: {
    ownerName: '', // 持卡人姓名"
    cardNumber: '', // 信用卡號16位數字
    expiredTime: '', // 有效年月MMYY
  },

  submitted: false,
  submittingMessage: '',
  submittedError: false,
};

const getDonationDefaultState = () => donationDefaultState;

export {
  getDonationDefaultState,
  donationDefaultState,
};
